import React from "react";
import moment from "moment";

const sessions = (formattedEvent, sessionFormatter) => {
    if(formattedEvent && formattedEvent.multiple_days){
        const days = formattedEvent.multiple_days_events;

        if(days.length > 2){
            return (
                <span>
                    {days.length} sessions between {moment(days[0].start_date).format('Do MMMM YYYY')} and {moment(days[days.length - 1].start_date).format('Do MMMM YYYY')}
                </span>
            )
        } else {
            return days.map((day, i) => <span style={{display: 'block'}} key={i}>{sessionFormatter(day)}</span>);
        }
    }else{
        return null;
    }
}

export default sessions;


// WEBPACK FOOTER //
// ./services/sessions.js